import { ReferClientForm } from "../../../core/types/ReferContainerTypes";

export const REFER_CLIENT_FORM: ReferClientForm[]  = [
	{
		label: 'refer.client.step1.title',
		isResponsiveLabel: true,
		sections: [
			{
				label: 'refer.client.personal.heading',
				prependedCopy: 'refer.client.personal.ReferalType',
				enterDetailsCopy: [
					{
						detailText: "refer.client.partner.Referring.client.details",
						condition: {
							name: 'customerType',
							value: ['PFX', 'CFX']
						}
					},
					{
						detailText: "refer.client.partner.Referring.affiliate.details",
						condition: {
							name: 'customerType',
							value: ['PARTNER']
						}
					}
				],
				switch: {
					name: 'customerType',
					options: [
						{ key: 'refer.client.form.customertype.individual', value: 'PFX' },
						{ key: 'refer.client.form.customertype.company', value: 'CFX' },
						{ key: 'refer.client.form.customertype.Partner', value: 'PARTNER' }
					]
				},
				type: 'input',
				fields: [
					{
						name: 'firstName',
						key: 'refer.client.form.firstname',
						component: 'text',
						required: true,
						//validation: /^([A-Za-z\/_\u0600-\u06FF\u3000\u3400-\u4DBF\u4E00-\u9FFF\u00C0-\u024F\u1E00-\u1EFF\/_\u0600-\u06ff]|([A-Za-z\/_\u0600-\u06FF\u3000\u3400-\u4DBF\u4E00-\u9FFF\u00C0-\u024F\u1E00-\u1EFF\/_\u0600-\u06ff][A-Za-z\/_\u0600-\u06FF\u3000\u3400-\u4DBF\u4E00-\u9FFF\u00C0-\u024F\u1E00-\u1EFF\/_\u0600-\u06ff ]{0,38}[A-Za-z\/_\u0600-\u06FF\u3000\u3400-\u4DBF\u4E00-\u9FFF\u00C0-\u024F\u1E00-\u1EFF\/_\u0600-\u06ff]))$/ig
						validation: /^\S.{0,39}$/,
						isCoralogixMasked:true
					},
					{
						name: 'lastName',
						key: 'refer.client.form.lastname',
						component: 'text',
						required: true,
						//validation: /^([A-Za-z\/_\u0600-\u06FF\u3000\u3400-\u4DBF\u4E00-\u9FFF\u00C0-\u024F\u1E00-\u1EFF\/_\u0600-\u06ff]|([A-Za-z\/_\u0600-\u06FF\u3000\u3400-\u4DBF\u4E00-\u9FFF\u00C0-\u024F\u1E00-\u1EFF\/_\u0600-\u06ff][A-Za-z\/_\u0600-\u06FF\u3000\u3400-\u4DBF\u4E00-\u9FFF\u00C0-\u024F\u1E00-\u1EFF\/_\u0600-\u06ff ]{0,38}[A-Za-z\/_\u0600-\u06FF\u3000\u3400-\u4DBF\u4E00-\u9FFF\u00C0-\u024F\u1E00-\u1EFF\/_\u0600-\u06ff]))$/ig
						validation: /^\S.{0,39}$/,
						isCoralogixMasked:true
					}
				]
			},
			{
				label: 'refer.client.company.heading',
				condition: {
					name: 'customerType',
					value: ['CFX']
				},
				type: 'input',
				fields: [
					{
						name: 'companyName',
						key: 'refer.client.form.companyname',
						component: 'text',
						required: true,
						// validation: /^[a-z !_.-\s0-9'&\u00C0-\u024F\u1E00-\u1EFF]{1,50}$/ig
						validation: /^\S.{0,49}$/
					},
					{
						name: 'trading_name',
						key: 'refer.client.form.tradingname',
						component: 'text',
						required: false,
						// validation: /^[a-z !_.-\s0-9'&\u00C0-\u024F\u1E00-\u1EFF]{1,100}$/ig
						validation: /^\S.{0,99}$/
					}
				]
			}
		]
	},
	{
		label: 'refer.client.step2.title',
		isResponsiveLabel: true,
		sections: [
			{
				label: 'refer.client.contact.heading',
				type: 'input',
				fields: [
					{
						name: 'email',
						key: 'refer.client.form.email',
						component: 'text',
						required: true,
						validation: /^(([a-zA-Z0-9!#$%&'*+-\/=?^_`{|]{1,64})([@]{1})([a-zA-Z0-9-.]{2,160})([.]{1})([a-zA-Z0-9-.]{2,24}))$/i, // eslint-disable-line
						isCoralogixMasked:true
					},
					{
						name: 'mobile',
						key: 'refer.client.form.mobile',
						component: 'combo',
						reference: 'dialing',
						required: true,
						validation: /^(\+)?([0-9]){10,16}$/i,
						isCoralogixMasked:true
					},
					{
						name: 'phone',
						key: 'refer.client.form.phone',
						component: 'combo',
						reference: 'dialing',
						required: false,
						validation: /^\+[0-9]{10,16}$/ig,
						isCoralogixMasked:true
					},
					{
						name: 'best_time_to_call',
						key: 'refer.client.form.besttime',
						component: 'select',
						reference: 'times',
						required: false,
						isCoralogixMasked:true
					}
				]
			}
		]
	},
	{
		label: 'refer.client.step3.title',
		isResponsiveLabel: true,
		condition: {
			name: 'customerType',
			value: ['PFX', 'CFX']
		},
		sections: [
			{
				label: 'refer.client.transaction.heading',
				type: 'input',
				fields: [
					{
						name: 'est_transaction_value',
						key: 'refer.client.form.transactionvalue',
						component: 'select',
						reference: 'transaction',
						required: true
					},
					{
						name: 'sellingCurrency',
						key: 'refer.client.form.sellingcurrency',
						component: 'select',
						reference: 'currency',
						required: true
					},
					{
						name: 'buyingCurrency',
						key: 'refer.client.form.buyingcurrency',
						component: 'select',
						reference: 'currency',
						required: true
					}
				]
			}
		]
	},
	{
		label: 'refer.client.partner.step3.title',
		isResponsiveLabel: true,
		condition: {
			name: 'customerType',
			value: ['PARTNER']
		},
		sections: [
			{
				label: 'refer.client.partner.heading',
				type: 'input',
				fields: [
					{
						name: 'nature_of_business',
						key: 'refer.client.form.whatdotheydo',
						component: 'text',
						required: true,
						validation: /^\S.{0,98}$/
					},
					{
						name: 'client_type',
						key: 'refer.client.form.clienttype',
						component: 'select',
						required: true,
						reference: 'clientTypes'
					},
					{
						name: 'website',
						key: 'refer.client.form.website',
						component: 'text',
						required: false,
						validation: /^(?=.{3,255}$)(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm
					},
				]
			}
		],
	},
	{
		label: 'refer.client.step4.title',
		isResponsiveLabel: true,
		sections: [
			{
				label: 'refer.client.confirm.heading',
				type: 'summary',
				summaries: [
					{
						key: 'refer.client.summary.fullname',
						combine: ['firstName', 'lastName'],
						isCoralogixMasked:true
					},
					{
						key: 'refer.client.summary.mobile',
						combine: ['mobile'],
						isCoralogixMasked:true
					},
					{
						key: 'refer.client.summary.email',
						combine: ['email'],
						isCoralogixMasked:true
					},
					{
						key: 'refer.client.summary.phone',
						combine: ['phone'],
						isCoralogixMasked:true
					},
					{
						key: 'refer.client.summary.sellingcurrency',
						combine: ['sellingCurrency'],
						condition: {
							name: 'customerType',
							value: ['PFX', 'CFX']
						}
					},
					{
						key: 'refer.client.summary.buyingcurrency',
						combine: ['buyingCurrency'],
						condition: {
							name: 'customerType',
							value: ['PFX', 'CFX']
						}
					},
					{
						key: 'refer.client.summary.transactionvalue',
						combine: ['est_transaction_value'],
						condition: {
							name: 'customerType',
							value: ['PFX', 'CFX']
						}
					},
					{
						key: 'refer.client.summary.whatdotheydo',
						combine: ['nature_of_business'],
						condition: {
							name: 'customerType',
							value: ['PARTNER']
						}
					},
					{
						key: 'refer.client.summary.clienttype',
						combine: ['client_type'],
						condition: {
							name: 'customerType',
							value: ['PARTNER']
						}
					},
					{
						key: 'refer.client.summary.website',
						combine: ['website'],
						condition: {
							name: 'customerType',
							value: ['PARTNER']
						}
					},
					{
						key: 'refer.client.summary.companyname',
						combine: ['companyName'],
						condition: {
							name: 'customerType',
							value: ['CFX']
						}
					},
					{
						key: 'refer.client.summary.tradingname',
						combine: ['trading_name'],
						condition: {
							name: 'customerType',
							value: ['CFX']
						}
					}
				]
			},
			{
				name: 'refer.client.notes.heading',
				type: 'input',
				fields: [
					{
						name: 'enquiry_info',
						key: 'refer.client.form.notes',
						component: 'multiline',
						required: false,
						validation: /^[\s\S]{0,32760}$/ig
					},
					{
						name: 'gdpr_opt_in',
						key: 'refer.client.form.gdpr',
						component: 'checkbox',
						required: true,
						condition: {
							name: 'customerType',
							value: ['PFX', 'CFX']
						}
					},
					{
						name: 'is_referral_agreed_to_share_contact_info',
						key: 'refer.client.form.share.contact',
						component: 'checkbox',
						required: true,
						condition: {
							name: 'customerType',
							value: ['PARTNER']
						}
					},
					{
						name: 'commission_opt_out',
						key: 'refer.client.form.commission',
						component: 'checkbox',
						required: false,
						condition: {
							name: 'customerType',
							value: ['PFX', 'CFX']
						}
					}
				]
			}
		]
	}
]